import { supabase } from "@/integrations/supabase/client";

const STORAGE_KEY = "talklot_ref_code";
const VISITOR_KEY = "talklot_visitor_token";
const CONSENT_KEY = "talklot_cookie_consent";

function consentGiven(): boolean {
  try { return localStorage.getItem(CONSENT_KEY) === "accepted"; } catch { return false; }
}

export function getVisitorToken(): string {
  try {
    let t = localStorage.getItem(VISITOR_KEY) || sessionStorage.getItem(VISITOR_KEY);
    if (!t) {
      t = (crypto.randomUUID?.() ?? `${Date.now()}-${Math.random().toString(36).slice(2)}`);
      if (consentGiven()) {
        localStorage.setItem(VISITOR_KEY, t);
      } else {
        sessionStorage.setItem(VISITOR_KEY, t);
      }
    }
    return t;
  } catch {
    return "anonymous";
  }
}

export function storeReferralCode(code: string) {
  try {
    if (consentGiven()) {
      localStorage.setItem(STORAGE_KEY, code);
      document.cookie = `talklot_ref=${encodeURIComponent(code)}; path=/; max-age=${60 * 60 * 24 * 30}; SameSite=Lax`;
    } else {
      sessionStorage.setItem(STORAGE_KEY, code);
    }
  } catch {}
}

export function readReferralCode(): string | null {
  try {
    const ls = localStorage.getItem(STORAGE_KEY);
    if (ls) return ls;
    const ss = sessionStorage.getItem(STORAGE_KEY);
    if (ss) return ss;
    const m = document.cookie.match(/(?:^|;\s*)talklot_ref=([^;]+)/);
    return m ? decodeURIComponent(m[1]) : null;
  } catch {
    return null;
  }
}

export function clearReferralCode() {
  try {
    localStorage.removeItem(STORAGE_KEY);
    sessionStorage.removeItem(STORAGE_KEY);
    document.cookie = "talklot_ref=; path=/; max-age=0";
  } catch {}
}

/** Attribute the currently-signed-in user to the stored referral code (if any). */
export async function attributeStoredReferral(): Promise<void> {
  const code = readReferralCode();
  if (!code) return;
  try {
    await (supabase.rpc as any)("attribute_referral", { p_code: code });
  } catch (e) {
    console.warn("attribute_referral failed", e);
  } finally {
    clearReferralCode();
  }
}

export function buildReferralLink(code: string): string {
  const origin = typeof window !== "undefined"
    ? (window.location.hostname.includes("talklot.site") ? "https://talklot.site" : window.location.origin)
    : "https://talklot.site";
  return `${origin}/ref/${code}`;
}
